import { styled, Typography, TypographyProps } from '@mui/material';

export const CountDownText = styled((props: TypographyProps) => (
  <Typography variant="body2" {...props} />
))<TypographyProps>(({ theme }) => ({
  color: theme.palette.neutral[800],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(0.5),
  height: 44,
  textAlign: 'center',
}));

export const CountDownSeconds = styled((props: TypographyProps) => (
  <Typography variant="body2Bold" component="span" {...props} />
))<TypographyProps>(({ theme }) => ({
  color: theme.palette.neutral[1000],
  display: 'inline-block',
  minWidth: 22,
  textAlign: 'left',
}));
